import React from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  DialogTitle,
  Box,
  Grid,
  styled,
  makeStyles,
  ErrorOutline as ErrorOutlineIcon,
} from '@quillbot/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import { toggleSessionDialogAction } from 'src/_common/actions/commonActions';
import Link from 'next/link';
import Track from '../../handlers/track';

const useStyle = makeStyles(() => ({
  dialog: {
    maxWidth: '500px',
    margin: 'auto',
  },
  paper: {
    margin: '16px',
  },
  paperWidthFalse: {
    maxWidth: 'calc(100% - 32px)',
  },
  paperScrollPaper: {
    maxHeight: 'calc(100% - 32px)',
  },
  dialogContent: {
    padding: '12px 20px 8px',
  },
  dialogAction: {
    padding: '8px 12px',
  },
}));

const StyledDialogTitle = styled(DialogTitle)`
  && {
    background: ${(props) => props.theme.palette.secondary.main};
    color: white;
    font-weight: 900;
    font-size: 20px;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const StyledIcon = styled(ErrorOutlineIcon)`
  && {
    font-size: 27px;
    float: left;
    margin-right: 0.2em;
  }
`;

const StyledButton = styled(Button)`
  && {
    color: ${(props) => props.theme.specialColors.BLUE_COLOR};
    font-weight: 600;
  }
`;

const StyledLink = styled('a')`
  color: ${(props) => props.theme.specialColors.BLUE_COLOR};
  cursor: pointer;
`;

const StyledTypography = styled(Typography)`
  color: #797979;
`;
function SessionDialog() {
  const renderSession = useSelector(
    (state: RootState) => state.common.session.isShown
  );
  if (renderSession) {
    Track.multipleSessionsError();
  }
  const dispatch = useDispatch();
  const classes = useStyle();
  const disableDialog = () =>
    dispatch(toggleSessionDialogAction({ isShown: false }));
  const isExtension = useSelector(
    (state: RootState) => state.common.platform.isExtension
  );

  return (
    <Dialog
      open={renderSession}
      maxWidth={false}
      classes={{
        root: classes.dialog,
        paper: classes.paper,
        paperWidthFalse: classes.paperWidthFalse,
        paperScrollPaper: classes.paperScrollPaper,
      }}
      onClose={() => dispatch(toggleSessionDialogAction({ isShown: false }))}
      aria-labelledby="alert-box-title"
      disableEscapeKeyDown
      aria-describedby="alert-box-description"
    >
      <StyledDialogTitle>
        <Grid container alignItems="center">
          <StyledIcon /> Multiple Active Sessions
        </Grid>
      </StyledDialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Box mt={1}>
          <StyledTypography>
            Due to multiple active sessions, your account has been temporarily
            disabled. Please log out from any other active QuillBot session or{' '}
            {isExtension ? (
              <a href="/settings" target="_blank">
                <StyledLink onClick={disableDialog}>
                  change your password{' '}
                </StyledLink>
              </a>
            ) : (
              <Link href="/settings">
                <StyledLink onClick={disableDialog}>
                  change your password{' '}
                </StyledLink>
              </Link>
            )}
            to secure your account. Completing any of these steps will
            reactivate your account in short period of time.
          </StyledTypography>
        </Box>
        <br />
        <StyledTypography>
          Learn more about{' '}
          {isExtension ? (
            <a href="/faq" target="_blank">
              <StyledLink onClick={disableDialog}>
                multiple active sessions.
              </StyledLink>
            </a>
          ) : (
            <Link href="/faq">
              <StyledLink onClick={disableDialog}>
                multiple active sessions.
              </StyledLink>
            </Link>
          )}
        </StyledTypography>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        {/* <Button style={{ fontWeight: 600 }} className="btn-link" onClick={disableDialog}>
          CANCEL
        </Button> */}
        {/* <Link href="/settings"> */}
        <StyledButton onClick={disableDialog}>I UNDERSTAND</StyledButton>
        {/* </Link> */}
      </DialogActions>
    </Dialog>
  );
}

export default SessionDialog;
